// export default () => ({
// })

export default () => ({
    generalInventory: [],
    generalInventoryPaginated: [],
    generalInventoryisLoading: false
})